<template>
  <v-app>
    <Nav/>
    <v-main class="content">
      <router-view></router-view>
    </v-main>
    <!-- <sign-up-pop-up
      :show.sync="showPopup"
    ></sign-up-pop-up> -->
    <we-have-moved
      :show.sync="showPopup"
    ></we-have-moved>
    <Footer/>
  </v-app>
</template>

<script>
import {
  VApp,
  VMain,
} from 'vuetify/lib'
import Footer from '@/components/Footer.vue'
import Nav from '@/components/Nav.vue'
import SignUpPopUp from '@/components/SignUpPopUp.vue'
import WeHaveMoved from '@/components/WeHaveMoved.vue'

export default {
  components: {
    Footer,
    Nav,
    SignUpPopUp,
    WeHaveMoved,
    VApp,
    VMain
  },
  created() {
    const excludes = ['privacy', 'terms']

    if (excludes.indexOf(this.$router.currentRoute.name) > -1) {
      this.showPopup = false
    }
  },
  data: () => ({
    exclude: ['home-deliveries', 'privacy'],
    showPopup: true,
  }),
}
</script>

<style lang="scss">
@import '@/styles/main.scss';
@import '@/styles/ckeditor.scss';

// .brand {
//   font-family: 'Fredericka the Great', cursive;
//   font-weight: normal;
//   letter-spacing: normal;
//   text-transform: uppercase;
// }

// h1, .heading1-fred {
//   font-family: 'Fredericka the Great', cursive;
//   font-weight: normal;
//   font-size: 35px;
//   margin-bottom: 10px;
// }

// h1.heading1-karla {
//   font-family: 'Karla', sans-serif;
//   font-weight: bold;
//   text-transform: none;
//   font-size: 40px;
//   margin-bottom: 10px;
// }

// h1.hidden {
//   display: none;
// }

// h3 {
//   font-weight: normal;
//   text-align: left;
//   text-transform: uppercase;
//   padding-bottom: 20px;
// }

// h5 {
//   font-size: 20px;
//   font-weight: bold;
// }

// p {
//   text-align: justify;

//   &.popup-heading {
//     text-align: center;
//     font-weight: bold;

//     &.large {
//       font-size: 20px;
//       padding-top: 10px;
//     }
//   }

//   &.popup-body {
//     text-align: center;

//     &.large {
//       padding: 20px 0 30px 0;
//     }
//   }
// }
// @media screen and (max-width: 960px) {
//   p {
//     font-size: 16px;
//   }
// }

// #app {
//   background: transparent;
//   font-family: 'Karla', sans-serif;
//   font-size: 18px;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
// }

.content {
  background: transparent;
  overflow: hidden;
  margin-top: 69px;
}

.menu-active {
  background-color: rgba(0,0,0,.13);
  color: black;
}

.roots {
  background-repeat: space 50 0;
  background-size: contain;
  height: 30px;
}
</style>
